import { render } from "./Error.vue?vue&type=template&id=132102b2"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/HelpDesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__